import { render, staticRenderFns } from "./Prijzen.vue?vue&type=template&id=53bcb6ff"
import script from "./Prijzen.vue?vue&type=script&lang=ts"
export * from "./Prijzen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports